import React from 'react';

interface SuccessWithBorderIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
    stroke?: string;
    className?: string;
}

export const SuccessWithBorderIcon: React.FC<SuccessWithBorderIconProps> = ({
    width = 45,
    height = 45,
    fill = 'none',
    stroke = 'white',
    className = '',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 25"
            fill={fill}
            className={className}
        >
            <path
                d="M12.5002 22.9167C13.8684 22.9183 15.2234 22.6497 16.4874 22.1261C17.7514 21.6025 18.8996 20.8343 19.8658 19.8656C20.8345 18.8994 21.6027 17.7513 22.1263 16.4872C22.6499 15.2232 22.9185 13.8682 22.9168 12.5C22.9185 11.1318 22.6499 9.77677 22.1263 8.51274C21.6027 7.24871 20.8345 6.1006 19.8658 5.13436C18.8996 4.1657 17.7514 3.3975 16.4874 2.8739C15.2234 2.35031 13.8684 2.08163 12.5002 2.08332C11.132 2.08163 9.77696 2.35031 8.51293 2.8739C7.2489 3.3975 6.10078 4.1657 5.13455 5.13436C4.16588 6.1006 3.39768 7.24871 2.87408 8.51274C2.35049 9.77677 2.08182 11.1318 2.0835 12.5C2.08182 13.8682 2.35049 15.2232 2.87408 16.4872C3.39768 17.7513 4.16588 18.8994 5.13455 19.8656C6.10078 20.8343 7.2489 21.6025 8.51293 22.1261C9.77696 22.6497 11.132 22.9183 12.5002 22.9167Z"
                stroke={stroke}
                stroke-width="2"
                stroke-linejoin="round"
            />
            <path
                d="M8.3335 12.5L11.4585 15.625L17.7085 9.375"
                stroke={stroke}
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
